import React from 'react';
import styles from '../../styles.module.css';
import { Blog } from '@/commonTypes';
import UserAvatar from '@/components/pages/profile/ProfileContent/AccountHero/UserInfo/UserAvatar';
import MainIcons from '@/icons/main';
import { blogBg } from '@/functions/formats';
import { useLocale } from 'next-intl';
import UserInfo from './UserInfo';

export default function BlogFooter({
  item,
  index,
  featured = false,
  className = '',
  userNameClass = '',
  metaClass = '',
  avatarClass = '',
  style = {},
  showRole = false,
  infoSectionStyle = '',
}: {
  item?: Blog;
  index?: number;
  featured?: boolean;
  className?: string;
  userNameClass?: string;
  metaClass?: string;
  avatarClass?: string;
  style?: any;
  showRole?: boolean;
  infoSectionStyle?: string;
}) {
  const locale = useLocale();
  return (
    <div className={`${styles.metaWrapper} ${className}`}>
      <div className={`${styles.avatarContainer}`}>
        <UserAvatar
          name={item?.user?.name}
          round={true}
          // colorNumber={index ? index : 0}
          style={{ background: index ? blogBg(index) : blogBg(0), ...style }}
          avatarClass={`${styles.avatar} ${featured && styles.featuredAvatar} ${avatarClass}`}
        />
      </div>
      <div className={`${styles.avatarWrapper} ${infoSectionStyle}`}>
        {item?.user && <UserInfo item={item} showRole={showRole} userNameClass={userNameClass} />}

        <div className={`${styles.meta} ${metaClass}`}>
          {item?.user?.role && <span className={`${styles.firstdot}`}>•</span>}
          <MainIcons.clockIcon width="14px" height="14px" fill="#b0b7c8" />
          {/* <span>{item?.date}</span> */}
          {item?.created_at && (
            <span>
              {new Date(item?.created_at).toLocaleDateString(locale == 'fa' ? 'fa-IR' : 'en-US')}{' '}
              .{' '}
            </span>
          )}
          <span>•</span>
          <span>{item?.read}</span>
        </div>
      </div>
    </div>
  );
}
